<div class="loader-wrapper" *ngIf="visible">
    <div class="loader">{{'loading' | languageTranslate}}...</div>
</div>
